import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type BarChartProps = IconComponentBaseProps;

export const BarChart = ({
  className,
  width = 16,
  height = 16,
  fill = defaultTheme.mantineColors.gray[7],
}: BarChartProps) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="bar_chart">
        <mask
          id="mask0_4913_106341"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="16"
          height="16"
        >
          <rect id="Bounding box" width="16" height="16" fill="currentColor" />
        </mask>
        <g mask="url(#mask0_4913_106341)">
          <path
            id="bar_chart_2"
            d="M11.2692 13C11.0985 13 10.9554 12.9422 10.8398 12.8267C10.7244 12.7112 10.6667 12.5681 10.6667 12.3973V9.66667C10.6667 9.496 10.7244 9.35289 10.8398 9.23733C10.9554 9.12189 11.0985 9.06417 11.2692 9.06417H12.3973C12.5681 9.06417 12.7112 9.12189 12.8267 9.23733C12.9422 9.35289 13 9.496 13 9.66667V12.3973C13 12.5681 12.9422 12.7112 12.8267 12.8267C12.7112 12.9422 12.5681 13 12.3973 13H11.2692ZM7.43583 13C7.26517 13 7.12206 12.9422 7.0065 12.8267C6.89106 12.7112 6.83333 12.5681 6.83333 12.3973V3.60267C6.83333 3.43189 6.89106 3.28878 7.0065 3.17333C7.12206 3.05778 7.26517 3 7.43583 3H8.56417C8.73483 3 8.87794 3.05778 8.9935 3.17333C9.10894 3.28878 9.16667 3.43189 9.16667 3.60267V12.3973C9.16667 12.5681 9.10894 12.7112 8.9935 12.8267C8.87794 12.9422 8.73483 13 8.56417 13H7.43583ZM3.60267 13C3.43189 13 3.28878 12.9422 3.17333 12.8267C3.05778 12.7112 3 12.5681 3 12.3973V6.87483C3 6.70106 3.05778 6.55667 3.17333 6.44167C3.28878 6.32678 3.43189 6.26933 3.60267 6.26933H4.73083C4.9015 6.26933 5.04461 6.32706 5.16017 6.4425C5.27561 6.55794 5.33333 6.70106 5.33333 6.87183V12.3943C5.33333 12.5682 5.27561 12.7126 5.16017 12.8275C5.04461 12.9425 4.9015 13 4.73083 13H3.60267Z"
            fill={fill}
          />
        </g>
      </g>
    </svg>
  );
};
